import {
  FaShieldAlt,
  FaFire,
  FaConciergeBell,
  FaUserTie,
  FaUserShield,
  FaMapMarkerAlt,
  FaParking,
  FaCamera,
  FaVideo,
  FaClipboardList,
  FaCogs,
  FaHeadset,
  FaBuilding,
  FaHome,
} from "react-icons/fa";
import Images from "../data/Images";
import { FaBuildingShield } from "react-icons/fa6";

export const services = [
  {
    id: "commercial-security",
    title: "Commercial Security",
    description: "Protecting businesses with expert security solutions.",
    icon: <FaBuilding className="text-red-800 text-3xl" />,
    details:
      "New Way Security provides customized security services for offices, retail centers, and industrial sites. Our commercial security guards ensure safety, prevent theft, and maintain order in busy business environments.",
    sections: [
      {
        title: "Asset Protection",
        content:
          "Safeguarding valuable company assets, merchandise, and equipment through vigilant monitoring and patrolling.",
        image: Images.event1,
      },
      {
        title: "Access Control",
        content:
          "Strict entry and exit control measures reduce risks and prevent unauthorized access to sensitive areas.",
        image: Images.event2,
      },
      {
        title: "24/7 Monitoring",
        content:
          "Around-the-clock protection ensures uninterrupted safety for businesses, even after working hours.",
        image: Images.h1,
      },
    ],
  },

  {
    id: "residential-security",
    title: "Residential Security",
    description: "Creating safe and secure living environments.",
    icon: <FaHome className="text-red-800 text-3xl" />,
    details:
      "Our residential security services protect neighborhoods, gated communities, and individual homes. New Way Security guards promote a safe atmosphere while assisting residents and visitors.",
    sections: [
      {
        title: "Neighborhood Patrols",
        content:
          "Regular patrols discourage suspicious activity and ensure residents feel secure at all times.",
        image: Images.event1,
      },
      {
        title: "Visitor Management",
        content:
          "Monitoring guest access and maintaining visitor logs improves accountability and community safety.",
        image: Images.event2,
      },
      {
        title: "Emergency Assistance",
        content:
          "From medical aid to crisis intervention, our guards are trained to support residents in critical moments.",
        image: Images.h1,
      },
    ],
  },

  {
    id: "vip-security",
    title: "VIP Security",
    description:
      "Discreet and professional protection for high-profile clients.",
    icon: <FaUserShield className="text-red-800 text-3xl" />,
    details:
      "Our VIP security services provide personal protection for executives, celebrities, and dignitaries. We combine discretion, advanced planning, and skilled personnel to ensure safety without disruption.",
    sections: [
      {
        title: "Close Protection",
        content:
          "Trained bodyguards ensure safety in public and private settings while minimizing intrusions.",
        image: Images.event1,
      },
      {
        title: "Secure Transportation",
        content:
          "From route planning to vehicle escorting, we guarantee secure travel for our VIP clients.",
        image: Images.event2,
      },
      {
        title: "Event Security",
        content:
          "Specialized teams manage crowd control and entry protocols during high-profile events.",
        image: Images.h1,
      },
    ],
  },

  {
    id: "condominium-security",
    title: "Condominium Security",
    description: "Specialized safety for residential buildings and complexes.",
    icon: <FaBuildingShield className="text-red-800 text-3xl" />,
    details:
      "We provide tailored security solutions for condominiums and apartment complexes, ensuring resident safety while maintaining a welcoming environment.",
    sections: [
      {
        title: "Lobby & Front Desk",
        content:
          "Security officers manage access points and provide assistance to residents and visitors.",
        image: Images.condo1,
      },
      {
        title: "Surveillance Integration",
        content:
          "Our guards work with CCTV and electronic systems to enhance monitoring and safety.",
        image: Images.condo2,
      },
      {
        title: "Community Support",
        content:
          "Trained staff assist with daily security needs, emergencies, and resident concerns.",
        image: Images.condo3,
      },
    ],
  },
  {
    id: "uniformed-security",
    title: "Uniformed Security",
    description: "Professional guards ensuring safety and visible deterrence.",
    icon: <FaShieldAlt className="text-red-800 text-3xl" />,
    details:
      "Uniformed guards from New Way Security provide a strong, visible presence that deters crime and promotes a safe environment. Our team is trained to handle diverse scenarios with professionalism and vigilance, ensuring peace of mind for businesses, residents, and institutions.",
    sections: [
      {
        title: "Visible Deterrence",
        content:
          "The presence of uniformed security acts as a powerful deterrent against unauthorized activity. Criminals are less likely to target areas monitored by professional guards from New Way Security.",
        image: Images.event1,
      },
      {
        title: "Customer Service & Support",
        content:
          "Our guards are trained not only in safety protocols but also in customer service. They assist visitors, employees, and residents while maintaining a secure and approachable presence.",
        image: Images.event2,
      },
      {
        title: "Emergency Preparedness",
        content:
          "New Way Security officers are extensively trained to handle emergencies — from medical incidents to evacuation procedures — ensuring rapid and effective response in critical situations.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "mobile-security",
    title: "Mobile Security",
    description: "Agile patrol units providing rapid response and deterrence.",
    icon: <FaShieldAlt className="text-red-800 text-3xl" />,
    details:
      "New Way Security mobile patrols provide flexible protection across wide areas such as industrial parks, neighborhoods, and construction sites. Our GPS-tracked vehicles and professional officers ensure proactive monitoring and fast response.",
    sections: [
      {
        title: "Flexible Coverage",
        content:
          "Mobile patrols adapt to the unique needs of each site, covering large or multiple locations efficiently.",
        image: Images.event1,
      },
      {
        title: "Proactive Deterrence",
        content:
          "The visible presence of patrol units prevents crime and reassures clients that their property is under constant watch.",
        image: Images.event2,
      },
      {
        title: "Rapid Response",
        content:
          "GPS-tracked vehicles enable our officers to respond quickly to alarms, suspicious activity, and emergencies.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "fire-watch-security",
    title: "Fire Watch Security",
    description: "Specialized fire risk monitoring and response.",
    icon: <FaFire className="text-red-800 text-3xl" />,
    details:
      "New Way Security offers professional fire watch services to safeguard properties when fire systems are down or during high-risk activities. Our officers monitor, report, and respond to fire hazards with diligence.",
    sections: [
      {
        title: "Constant Monitoring",
        content:
          "Our fire watch guards patrol at scheduled intervals to check for signs of smoke, fire, or hazards.",
        image: Images.event1,
      },
      {
        title: "Regulatory Compliance",
        content:
          "We ensure compliance with safety regulations by maintaining logs and following fire watch protocols.",
        image: Images.event2,
      },
      {
        title: "Emergency Response",
        content:
          "Our guards are trained to initiate emergency procedures immediately in case of fire, minimizing risk.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "concierge-security",
    title: "Concierge Security",
    description: "Blending hospitality with safety for residents and guests.",
    icon: <FaConciergeBell className="text-red-800 text-3xl" />,
    details:
      "At New Way Security, our concierge personnel combine professional security training with hospitality skills, providing a safe and welcoming environment in condominiums, offices, and residential communities.",
    sections: [
      {
        title: "First Point of Contact",
        content:
          "Our concierge staff greet residents and visitors, ensuring secure access control while providing a friendly face.",
        image: Images.event1,
      },
      {
        title: "Emergency Readiness",
        content:
          "Trained to handle medical or safety emergencies with speed and precision, ensuring resident well-being.",
        image: Images.event2,
      },
      {
        title: "Assistance & Support",
        content:
          "From coordinating deliveries to answering resident queries, our concierge services enhance daily life.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "elite-suite-tie-security",
    title: "Elite Suit & Tie Security",
    description: "Discreet professional protection for high-profile clients.",
    icon: <FaUserTie className="text-red-800 text-3xl" />,
    details:
      "New Way Security offers elite security officers in formal attire, providing discreet and polished protection tailored for executive events, VIPs, and luxury environments.",
    sections: [
      {
        title: "Professional Presence",
        content:
          "Elite officers project confidence and professionalism while maintaining a low profile.",
        image: Images.event1,
      },
      {
        title: "Discreet Protection",
        content:
          "Ideal for executive meetings, private events, and luxury settings where appearance matters.",
        image: Images.event2,
      },
      {
        title: "Tailored Services",
        content:
          "Our team adapts to the environment and client needs, ensuring both safety and sophistication.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "executive-protection",
    title: "Executive Protection",
    description: "Close protection services for executives and VIPs.",
    icon: <FaUserShield className="text-red-800 text-3xl" />,
    details:
      "New Way Security’s executive protection specialists safeguard individuals at higher risk, including business leaders, dignitaries, and celebrities, with discretion and professionalism.",
    sections: [
      {
        title: "Risk Assessment",
        content:
          "We conduct detailed threat assessments and customize protection plans for each client.",
        image: Images.event1,
      },
      {
        title: "Close Protection",
        content:
          "Highly trained officers provide close, discreet protection in both public and private settings.",
        image: Images.event2,
      },
      {
        title: "Travel Security",
        content:
          "Clients are protected during transit with secure routes, vehicle checks, and logistical planning.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "gatehouse-security",
    title: "Gatehouse Security",
    description: "Access control and monitoring at facility entrances.",
    icon: <FaMapMarkerAlt className="text-red-800 text-3xl" />,
    details:
      "New Way Security provides dedicated gatehouse officers to control access, verify visitors, and safeguard facility perimeters, ensuring that only authorized personnel enter.",
    sections: [
      {
        title: "Visitor Verification",
        content:
          "Gatehouse officers check credentials and verify access before granting entry.",
        image: Images.event1,
      },
      {
        title: "Perimeter Protection",
        content:
          "Our team ensures that entry and exit points are monitored and secure 24/7.",
        image: Images.event2,
      },
      {
        title: "Reporting & Logs",
        content:
          "Detailed logs of all visitor and vehicle entries provide accountability and transparency.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "parking-solutions",
    title: "Parking Solutions",
    description: "Fair and professional enforcement of parking rules.",
    icon: <FaParking className="text-red-800 text-3xl" />,
    details:
      "New Way Security offers parking enforcement solutions to maintain order in residential, commercial, and event spaces, ensuring fairness and compliance.",
    sections: [
      {
        title: "Vehicle Access Management",
        content:
          "We monitor and regulate vehicle entry, preventing unauthorized access.",
        image: Images.event1,
      },
      {
        title: "Rule Enforcement",
        content:
          "Our officers ensure compliance with parking regulations, issuing warnings or violations when necessary.",
        image: Images.event2,
      },
      {
        title: "Customer Assistance",
        content:
          "Beyond enforcement, our personnel assist drivers with directions and parking support.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "event-security",
    title: "Event Security",
    description: "Tailored protection for events large and small.",
    icon: <FaShieldAlt className="text-red-800 text-3xl" />,
    details:
      "New Way Security provides comprehensive event security services to protect guests, staff, and assets at public, private, and corporate events.",
    sections: [
      {
        title: "Crowd Control",
        content:
          "Our teams ensure safe movement of attendees, preventing overcrowding and incidents.",
        image: Images.event1,
      },
      {
        title: "Access Control",
        content:
          "Credential checks and controlled entry prevent unauthorized access to secure areas.",
        image: Images.event2,
      },
      {
        title: "Emergency Response",
        content:
          "Prepared for medical or safety incidents, our personnel coordinate with authorities for rapid response.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "camera-installations",
    title: "Camera Installations",
    description: "Advanced surveillance system setup and integration.",
    icon: <FaCamera className="text-red-800 text-3xl" />,
    details:
      "New Way Security installs state-of-the-art surveillance systems tailored to client needs, enhancing monitoring and security for residential, commercial, and industrial sites.",
    sections: [
      {
        title: "Custom Solutions",
        content:
          "We design and install camera systems based on property layout and security requirements.",
        image: Images.event1,
      },
      {
        title: "High-Tech Equipment",
        content:
          "Our installations use modern cameras with night vision, motion detection, and remote access.",
        image: Images.event2,
      },
      {
        title: "System Integration",
        content:
          "We integrate cameras with alarms and monitoring platforms for comprehensive security.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "camera-monitoring",
    title: "Camera Monitoring",
    description: "24/7 live video surveillance and threat detection.",
    icon: <FaVideo className="text-red-800 text-3xl" />,
    details:
      "New Way Security provides remote and on-site camera monitoring services to ensure real-time oversight, quick incident response, and proactive threat management.",
    sections: [
      {
        title: "Real-Time Monitoring",
        content:
          "Our monitoring teams watch live feeds to detect suspicious activity instantly.",
        image: Images.event1,
      },
      {
        title: "Incident Reporting",
        content:
          "Every event is documented and escalated to the appropriate authorities or clients immediately.",
        image: Images.event2,
      },
      {
        title: "Proactive Intervention",
        content:
          "Early detection allows for faster response, reducing the impact of threats or incidents.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "loss-prevention",
    title: "Loss Prevention",
    description: "Retail and asset protection services.",
    icon: <FaClipboardList className="text-red-800 text-3xl" />,
    details:
      "New Way Security specializes in loss prevention strategies for retailers and businesses, reducing shrinkage and protecting assets with experienced professionals.",
    sections: [
      {
        title: "Theft Deterrence",
        content:
          "Our officers deter shoplifting and theft through visibility and active monitoring.",
        image: Images.event1,
      },
      {
        title: "Investigations",
        content:
          "We conduct internal investigations to identify and reduce loss from employee theft.",
        image: Images.event2,
      },
      {
        title: "Policy Enforcement",
        content:
          "Security staff ensure compliance with company policies, reducing liability and risk.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "security-systems",
    title: "Security Systems",
    description: "Integrated alarm and access control solutions.",
    icon: <FaCogs className="text-red-800 text-3xl" />,
    details:
      "New Way Security designs, installs, and manages integrated security systems, including alarms, access control, and surveillance, to safeguard people and property.",
    sections: [
      {
        title: "Alarm Systems",
        content:
          "We install advanced alarms with instant alerts for intrusions, fire, or emergencies.",
        image: Images.event1,
      },
      {
        title: "Access Control",
        content:
          "Our solutions regulate and track who enters restricted areas with keycards or biometric access.",
        image: Images.event2,
      },
      {
        title: "System Integration",
        content:
          "We unify alarms, cameras, and monitoring into one seamless platform for full protection.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "consulting-services",
    title: "Consulting Services",
    description: "Expert advice for tailored security strategies.",
    icon: <FaHeadset className="text-red-800 text-3xl" />,
    details:
      "New Way Security provides consulting services that help businesses, institutions, and communities assess risks, design security plans, and implement effective strategies.",
    sections: [
      {
        title: "Risk Assessment",
        content:
          "Our experts analyze vulnerabilities and threats to provide actionable recommendations.",
        image: Images.event1,
      },
      {
        title: "Tailored Strategies",
        content:
          "We develop custom security plans that align with your operational needs and goals.",
        image: Images.event2,
      },
      {
        title: "Implementation Support",
        content:
          "Our consultants work closely with clients to ensure smooth deployment of security measures.",
        image: Images.h1,
      },
    ],
  },
  {
    id: "tailored-services",
    title: "Tailored Services",
    description: "Custom security plans designed for unique needs.",
    icon: <FaCogs className="text-red-800 text-3xl" />,
    details:
      "New Way Security understands that every client has different requirements. We offer tailored security programs that align with specific industries, events, or personal needs.",
    sections: [
      {
        title: "Flexible Solutions",
        content:
          "From temporary assignments to long-term deployments, our services adapt to your needs.",
        image: Images.tailored1,
      },
      {
        title: "Industry-Specific Expertise",
        content:
          "We design security strategies for sectors such as healthcare, education, retail, and logistics.",
        image: Images.tailored2,
      },
      {
        title: "Collaborative Planning",
        content:
          "Working closely with clients, we develop proactive strategies that balance safety and efficiency.",
        image: Images.tailored3,
      },
    ],
  },
];
